import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ReservationService } from 'core-lib';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-payment-cancel',
    imports: [TranslateModule, ButtonModule],
    templateUrl: './payment-cancel.component.html',
    styleUrl: './payment-cancel.component.scss'
})
export class PaymentCancelComponent implements OnInit {

  constructor(
    private reservationService: ReservationService,
    private router: Router
  ) {}
  
  ngOnInit() {
    this.reservationService.redirectToProfileAfterFailedPayment(window.location.search);
  }

  goToProfile() {
    this.router.navigate(['profile']);
  }
}
